import React from 'react';

import moment from 'moment';
import 'moment/locale/tr';
import locale from 'antd/es/date-picker/locale/tr_TR';

import { DatePicker, Space } from 'antd';

export default class Example extends React.Component {

  focusTo() {
    // Focus to `to` field. A timeout is required here because the overlays
    // already set timeouts to work well with input fields
    this.timeout = setTimeout(() => this.to.getInput().focus(), 0);
  }
  render() {
    const { RangePicker } = DatePicker;
    const dateFormat = 'DD.MM.YYYY';
    const { from, to } = this.props.state;
    const modifiers = { start: from, end: to };
    return <Space direction="vertical" size={12}>
          <RangePicker
          size="large"
            ranges={{
              'Son Bir Hafta': [moment().subtract(1,'w'),moment()],
              'Son Bir Ay': [moment().subtract(1,'M'),moment()],
              'Son Bir Yıl': [moment().subtract(1,'Y'),moment()],
              'Bugun': [moment(), moment()],
              'Bu Ay': [moment().startOf('month'), moment().endOf('month')],
              'Bu Yıl': [moment().startOf('year'), moment().endOf('year')],
            }}
            format={dateFormat}
            locale={locale}
            onChange={(date, dateString) => {
              console.log(date, dateString);
              this.props._baslangicTarihSet(dateString)
            }}
          />
        </Space>
       
  
  }
}
